// Configuration du bar - Blocs modulables
// Chaque bloc a une position (x, y) sur la grille et peut etre deplace

const barConfig = {
  // Taille de la grille (en cellules)
  gridCols: 32,
  gridRows: 20,
  cellSize: 55, // pixels par cellule

  // Types de blocs disponibles pour le palette
  blockTypes: [
    { type: 'etagere', label: 'Etagere', icon: '🗄️', width: 4, height: 2, color: '#e3f2fd', borderColor: '#1565c0', levels: 3, slotsPerLevel: 6 },
    { type: 'comptoir', label: 'Comptoir', icon: '▬', width: 5, height: 2, color: '#d7ccc8', borderColor: '#8d6e63', levels: 1, slotsPerLevel: 8 },
    { type: 'frigo', label: 'Frigo', icon: '❄', width: 2, height: 2, color: '#e0f7fa', borderColor: '#00838f', levels: 3, slotsPerLevel: 3 },
    { type: 'vitrine', label: 'Vitrine', icon: '🪟', width: 6, height: 2, color: '#fff3e0', borderColor: '#e65100', levels: 3, slotsPerLevel: 8 },
    { type: 'mur', label: 'Mur', icon: '▮', width: 4, height: 1, color: '#bdbdbd', borderColor: '#616161', levels: 0, slotsPerLevel: 0 },
    { type: 'entree', label: 'Entree', icon: '🚪', width: 2, height: 1, color: '#a5d6a7', borderColor: '#2e7d32', levels: 0, slotsPerLevel: 0 },
  ],

  // Blocs places par defaut
  blocks: [
    { id: 'vitrine-1', type: 'vitrine', label: 'Vitrine Arriere', x: 7, y: 0, width: 6, height: 2, levels: 3, slotsPerLevel: 8 },
    { id: 'etagere-gauche', type: 'etagere', label: 'Etagere Gauche', x: 3, y: 3, width: 4, height: 2, levels: 3, slotsPerLevel: 6 },
    { id: 'etagere-droite', type: 'etagere', label: 'Etagere Droite', x: 13, y: 3, width: 4, height: 2, levels: 3, slotsPerLevel: 6 },
    { id: 'comptoir-1', type: 'comptoir', label: 'Comptoir Central', x: 7, y: 5, width: 5, height: 2, levels: 1, slotsPerLevel: 8 },
    { id: 'frigo-1', type: 'frigo', label: 'Frigo', x: 1, y: 3, width: 2, height: 2, levels: 3, slotsPerLevel: 3 },
    { id: 'entree-1', type: 'entree', label: 'Entree', x: 9, y: 12, width: 2, height: 1 },
  ],
};

export default barConfig;
